<template>
  <div
    class="modal fade"
    id="importLocationsModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>

          <h4 class="modal-title">
            <b>{{ lang.LIM000 }}</b>
          </h4>
        </div>
        <div class="modal-body">
          <form>
            <div
              class="form-group fg-client-select"
              v-if="clientList.length > 1"
            >
              <label
                for="locationImportClientSelect"
                class="col-md-2 control-label"
                >{{ lang.LIM010 }}</label
              >
              <div class="col-md-10">
                <select2
                  class="form-control"
                  id="locationImportClientSelect"
                  v-model="selectedClient"
                  :placeholder="lang.LIM010"
                >
                  <option></option>
                  <option
                    v-for="client in clientList"
                    :key="client.ClientGuid"
                    :value="client.ClientGuid"
                  >
                    {{ client.ClientName }}
                  </option>
                </select2>
              </div>
            </div>

            <div class="form-group">
              <ul class="nav nav-tabs nav-import" style="margin-bottom: 15px">
                <li class="active">
                  <a
                    href="#textImport"
                    data-toggle="tab"
                    @click="importOption = 'text'"
                    >{{ lang.LIM001 }}</a
                  >
                </li>
                <li v-if="globals.isAccessAllowed('LoopOp_Upload_Create')">
                  <a
                    href="#fileImport"
                    data-toggle="tab"
                    @click="importOption = 'file'"
                    >{{ lang.LIM002 }}</a
                  >
                </li>
              </ul>
              <div id="importTabContent" class="tab-content">
                <div class="tab-pane fade active in" id="textImport">
                  <label for="textAreaImport" class="col-md-1 control-label">{{
                    lang.LIM003
                  }}</label>
                  <div class="col-md-11">
                    <textarea
                      class="form-control"
                      rows="7"
                      id="textAreaImport"
                      v-model="importText"
                    ></textarea>
                    <span class="help-block">{{ lang.LIM004 }}</span>
                  </div>
                  <button
                    type="button"
                    class="btn"
                    style="margin-top: 30px"
                    @click="trimImportData = !trimImportData"
                  >
                    <i v-if="trimImportData" class="material-icons md-24"
                      >check_box</i
                    >
                    <i v-else class="material-icons md-24"
                      >check_box_outline_blank</i
                    >
                    {{ lang.LIM009 }}
                  </button>
                </div>

                <div class="tab-pane fade" id="fileImport">
                  <label for="inputFileImport" class="col-md-1 control-label">{{
                    lang.LIM005
                  }}</label>
                  <div class="col-md-11">
                    <input
                      id="locationImportFileInput"
                      class="form-control nopadding"
                      type="file"
                      accept=".xlsx"
                      @change="onImportFileChange"
                    />
                    <div class="input-group">
                      <label v-if="!selectedFile.name">{{ lang.LIM006 }}</label>
                      <label v-else>{{ selectedFile.name }}</label>
                      <span class="input-group-btn input-group-sm">
                        <button type="button" class="btn btn-fab btn-fab-mini">
                          <i class="material-icons">attach_file</i>
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-md-11">
                    <button
                      type="button"
                      class="btn"
                      style="margin-top: 30px"
                      v-show="false"
                      @click="trimImportData = !trimImportData"
                    >
                      <i v-if="trimImportData" class="material-icons md-24"
                        >check_box</i
                      >
                      <i v-else class="material-icons md-24"
                        >check_box_outline_blank</i
                      >
                      {{ lang.LIM009 }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            {{ lang.LIM007 }}
          </button>
          <button
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="uploadImportData()"
          >
            {{ lang.LIM008 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "LocationImportDataModal",
  components: { Select2 },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      importOption: "text",
      trimImportData: false,
      importText: "",
      selectedFile: {},
      selectedClient: "",
      clientList: [],
      lang: {
        LIM000: "Location import",
        LIM001: "Text import",
        LIM002: "File import",
        LIM003: "Text",
        LIM004: "Please insert the table data to be imported here.",
        LIM005: "File",
        LIM006: "Please select a file...",
        LIM007: "Cancel",
        LIM008: "OK",
        LIM009: "Clean data",
        LIM010: "Client",
        LIM011: "No client selected",
        LIM012: "Please insert import data",
        LIM013: "Please select an import file",
        LIM014: "Location import failed",
      },
    };
  },
  watch: {
    showModal(newValue) {
      newValue ? this.openModal() : this.closeModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);
    this.globals.getClientList((data) => {
      this.clientList = data;
      if (this.clientList.length === 1)
        this.selectedClient = this.clientList[0].ClientGuid;
    });

    $("#importLocationsModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed");
      if (this.$locationImportSuccess) {
        delete this.$locationImportSuccess;
        this.$router.push({
          path: `locationimport/${this.selectedClient}`,
        });
      }
    });
  },
  methods: {
    openModal() {
      this.importText = "";
      this.selectedFile = {};
      $("#importLocationsModal").modal("show");
    },
    closeModal() {
      $("#importLocationsModal").modal("hide");
    },
    uploadImportData() {
      if (!this.selectedClient) {
        this.globals.showErrorSnackbar(this.lang.LIM011);
        return;
      }
      let requestData;
      if (this.importOption === "text") {
        if (!this.importText) {
          this.globals.showErrorSnackbar(this.lang.LIM012);
          return;
        }
        // Escape all " characters
        let importText = this.importText.replace(/"/g, '\\"');
        requestData = `{"data":"${importText}","trim":${this.trimImportData}}`;
      } else {
        if (_.isEmpty(this.selectedFile)) {
          this.globals.showErrorSnackbar(this.lang.LIM013);
          return;
        }
        requestData = `{"file":"${this.selectedFile.file}","trim":${this.trimImportData}}`;
      }

      $.ajax({
        method: "POST",
        url: `api/Locations/Import/${this.selectedClient}`,
        data: requestData,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        timeout: 600000,
        success: (data) => {
          this.$locationImportSuccess = true;
          $("#importLocationsModal").modal("hide");
        },
        error: (data) => {
          console.error("Error on POST in uploadImportData()");
          this.globals.showErrorSnackbar(this.lang.LIM014);
        },
        complete: () => {
          this.importText = "";
          $("#locationImportFileInput")[0].value = null;
        },
      });
    },

    // Writes the filename to the input of the file import, after a file was selected
    onImportFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.selectedFile = {};
        return;
      }
      let fileObject = files[0];

      let uploadSuccess = (data) => {
        if (this.selectedFile) {
          this.selectedFile.file = data[0].DownloadId;
          this.selectedFile.name = fileObject.name;
        } else this.selectedFile = data;

        this.$forceUpdate();
      };
      this.globals.uploadFile(fileObject, uploadSuccess);
      e.target.value = null;
    },
  },
};
</script>

<style scoped>
.nav-import {
  background-color: var(--color-primary);
}
.nav-import > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav-import > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}

.fg-client-select {
  margin-bottom: 20px;
}

.input-group > label {
  padding-top: 10px;
}

.modal-dialog .form-group.is-focused .help-block {
  display: block;
}
</style>



// WEBPACK FOOTER //
// LocationImportDataModal.vue?9d962ca8